import { Box, Button, Typography } from '@mui/material';
import React from 'react'
import Glide from 'react-glidejs'

import "react-glidejs/dist/index.css";
function Carousel() {

    const data = [
        {
            background: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/bltb0ba20c0f463263c/642f0c296990415bbfc0c8d3/OW2_2023_S04_BlizzDotCom_Desktop_1600x720.jpg?format=webply&quality=80&auto=webp',
            logo: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt3ebf73c74f407c8d/6228f5a7f2c2644f956a88de/Overwatch2_logo.webp?format=webply&quality=80&auto=webp',
            text: 'La saison 4 a commencé',
            btn: 'En savoir plus'

        },
        {
            background: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt3c6f84ffc883974a/63d3fd8133d2117644a4a797/14_2022_10_Diablo_D4_Pre_Purchase_Blizzard_Channels_Blizzardcom_Desktop_1600x720_TS01.jpg?format=webply&quality=80&auto=webp',
            logo: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt20214fa1621e391d/638aab95e5d09810cdaff6d3/DIABLO_LOGO_520x300.png?format=webply&quality=80&auto=webp',
            text: 'Le test de charge de serveur aura lieu du 12 au 14 mai',
            btn: 'En savoir plus'

        },
        {
            background: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt7cf1bb52b5ce0751/642f04f41d100f6ea425c99f/HS_26p0_MotLK_Expansion-NowLive_BlizzardCom_Desktop_1600x720_BK01.jpg?format=webply&quality=80&auto=webp',
            logo: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt9aa196f844d0ca72/640fc3854f98c853eaf09be3/HS_26p0_Logo_launch_frFR_316x220.png?format=webply&quality=80&auto=webp',
            text: 'La nouvelle extension est maintenant disponible !',
            btn: 'Acheter le ticket de la taverne'

        },
        {
            background: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/bltb7c4ff67b4c44ca4/64139eb4998e686b2e53bbd2/WOW_10.0.7_ForbiddenReach_pve_stat_enus_desktop_1600x720.png?format=webply&quality=80&auto=webp',
            logo: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt5bbeee8e2cecba70/62a28a62a6a544113cef04d0/wow_dragonflight_golden_logo.png?format=webply&quality=80&auto=webp',
            text: 'Retour dans les confins interdits',
            btn: 'En savoir plus'

        },
        {
            background: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/bltecfee1d8d85dfb91/641dfbe24f98c853eaf09e61/DIA_DI_Patch18_CursedTower_Announce_bchblizz_enus_BN01-1600x720.png?format=webply&quality=80&auto=webp',
            logo: 'https://blz-contentstack-images.akamaized.net/v3/assets/blta8f9a8e092360c6c/blt1e36e43835b09e0d/6255a78d0f303644adfe5ee8/DIABLO_Immortal_VectorLogo_White_FINAL.webp?format=webply&quality=80&auto=webp',
            text: `L'ère des tours caduques est maintenant disponible `,
            btn: 'En savoir plus'

        },

    ]
    const gliderRef = React.useRef(null);
    return (
        // Carousel with glide.js inspired by https://www.blizzard.com/fr-fr/
        <div className='carousel-container' style={{ position: "relative", }}>
            <Glide
                type='carousel'
                autoplay={4000}
                perView={1}
                startAt={0}
                ref={gliderRef}
                peek={{ before: 0, after: 0 }}

            >
                {data.map((item, index) => (
                    <Box
                        key={index}
                        component="div"
                        className="glide__slide"
                        sx={{
                            backgroundImage: `url(${item.background})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "720px",
                            width: "100%",
                            position: "relative",
                            boxShadow: "1px 12px 36px 13px #000000",


                        }}
                    >
                        <Box
                            component="div"
                            sx={{
                                backgroundImage: `url(${item.logo})`,
                                backgroundSize: "contain",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                width: "380px",
                                height: "168px",
                                marginBottom: "16px",

                            }}
                        ></Box>
                        <Typography variant="h2" mb={3} color="white" sx={{ textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)" }}>
                            {item.text}
                        </Typography>
                        <Button
                            className='button-slide'
                        >
                            {item.btn}
                        </Button>
                    </Box>
                ))}

            </Glide>
        </div>

    )
}

export default Carousel